// components/DeleteConfirmationModal.jsx
import React from "react";

const DeleteConfirmationModal = ({
    open,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText = "Delete",
    cancelText = "Cancel",
}) => {
    if (!open) return null;

    return (
        <div className="fixed z-50 inset-0 flex items-center justify-center overflow-y-auto">
            <div className="fixed inset-0 bg-black/20 backdrop-blur-sm"></div>
            <div className="bg-white rounded-lg shadow-lg z-50 w-full max-w-md mx-auto p-6 relative">
                <div className="flex items-center space-x-3">
                    <div className="bg-red-100 p-2 rounded-full" onClick={onCancel}
                    >
                        <svg
                            className="h-6 w-6 text-red-700"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900">{title}</h3>
                </div>
                <p className="mt-3 text-sm text-gray-600">{message}</p>

                <div className="mt-6 flex justify-end space-x-2">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-sm bg-white border border-gray-300 rounded hover:bg-gray-100"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 text-sm bg-red-700 text-white rounded hover:bg-red-800"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
